import { createAsyncThunk } from '@reduxjs/toolkit';
import { Axios } from 'api/axios';

export const fetchAllOrganizations = createAsyncThunk(
  'warehouse/fetchAllOrganizations',
  async () => {
    const res = await Axios.get('/organization/all-org/');
    return res.data;
  }
);

export const fetchAllDepartments = createAsyncThunk(
  'warehouse/fetchAllDepartments',
  async () => {
    const res = await Axios.get('/department/get-all/');
    return res.data;
  }
);

export const fetchAllTeams = createAsyncThunk(
  'warehouse/fetchAllTeams',
  async () => {
    const res = await Axios.get('/teams/get-all');
    return res.data;
  }
);

export const fetchAllUserTypes = createAsyncThunk(
  'warehouse/fetchAllUserTypes',
  async () => {
    const res = await Axios.get('/user-types/');
    return res.data;
  }
);